import React from 'react'

import { SpacingProps, useSpacingProps } from '@/hooks/useSpacingProps'

import { BackgroundType, Container, Content, Heading } from './styles'

export interface SectionProps extends SpacingProps {
  backgroundType?: BackgroundType
  gap?: number
  children: React.ReactNode
}

type SectionComponentType = React.FC<SectionProps> & {
  Heading: typeof Heading
  Content: typeof Content
}

export const Section: SectionComponentType = ({
  backgroundType = 'default',
  gap = 6,
  children,
  ...spacingProps
}: SectionProps) => {
  const { padding, margin } = useSpacingProps(spacingProps)
  return (
    <Container
      backgroundType={backgroundType}
      padding={padding}
      margin={margin}
      gap={gap}
    >
      {children}
    </Container>
  )
}

Section.Heading = Heading
Section.Content = Content
